import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

// Optional background image behind a page hero. Falls back to the existing
// carbon-texture look when no banner image is set in the CMS.
export const HeroBanner = ({ src }) =>
  src ? (
    <div className="absolute inset-0" data-testid="page-hero-banner">
      <img src={src} alt="" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/75" />
    </div>
  ) : null;


export const SectionHeading = ({ eyebrow, title, description, align = "left", light }) => (
  <div className={`mb-12 ${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
    {eyebrow && (
      <span className="mb-3 inline-block text-xs font-bold uppercase tracking-[0.25em] text-primary">
        {eyebrow}
      </span>
    )}
    <h2
      className={`font-heading text-4xl font-bold tracking-tight md:text-5xl ${
        light ? "text-white" : "text-foreground"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>
        {description}
      </p>
    )}
  </div>
);
